import { render } from "./EbayCategories.vue?vue&type=template&id=a99d71d2&scoped=true"
import script from "./EbayCategories.vue?vue&type=script&lang=js"
export * from "./EbayCategories.vue?vue&type=script&lang=js"

import "./EbayCategories.vue?vue&type=style&index=0&id=a99d71d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99d71d2"]])

export default __exports__